import { render, staticRenderFns } from "./sysuser.vue?vue&type=template&id=60bd6d40"
import script from "./sysuser.vue?vue&type=script&lang=js"
export * from "./sysuser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports